/**
 * Production-safe logging utility
 *
 * Only logs in development mode (NODE_ENV !== 'production')
 * Use this instead of console.log to prevent debug logs in production
 */

const isDev = process.env.NODE_ENV !== 'production';

export const logger = {
    log: (...args: any[]) => {
        if (isDev) {
            console.log(...args);
        }
    },

    info: (...args: any[]) => {
        if (isDev) {
            console.info(...args);
        }
    },

    warn: (...args: any[]) => {
        // Warnings are shown in both dev and prod
        console.warn(...args);
    },

    error: (...args: any[]) => {
        // Errors are shown in both dev and prod
        console.error(...args);
    },

    debug: (...args: any[]) => {
        if (isDev) {
            console.debug(...args);
        }
    },

    // For tracking/analytics logging that should be visible in dev
    track: (eventName: string, properties?: Record<string, any>) => {
        if (isDev) {
            console.log(`[Track] ${eventName}`, properties);
        }
    },
};

export default logger;
